import { useTranslation } from 'react-i18next';
import { Button } from '@aqarmap/aqarmap-ui';
import Modal from '~/components/Modal';
import {
  useLogoutFromAllDevicesMutation,
  authApi,
} from '~/redux/api/authApiSlice';
import { clearToken } from '~/redux/utils';
import { closeModal } from '~/redux/features/uiState/uiStateSlice';
import { useAppDispatch } from '~/redux/hooks';

type LogoutFromDevicesModalProps = {
  setLogoutErrorMessage: (message: string) => void;
};

const LogoutFromDevicesModal = ({
  setLogoutErrorMessage,
}: LogoutFromDevicesModalProps) => {
  const dispatch = useAppDispatch();
  const { t, i18n } = useTranslation('app');
  const locale = i18n.language;
  const authBaseUrl = (process.env.REACT_APP_AUTH_SVC_ENDPOINT ?? '').replace(
    /\/+$/,
    '',
  );
  const baseUrl = (process.env.REACT_APP_BASE_URL ?? '').replace(/\/+$/, '');
  const logoutPageUrl = `${authBaseUrl}/logout?returnTo=${baseUrl}/${locale}/logout`;
  const [logoutFromAllDevices, { isLoading }] =
    useLogoutFromAllDevicesMutation();

  const handleClose = () => {
    setLogoutErrorMessage('');
    dispatch(closeModal('logoutFromDevicesModal'));
  };

  const onSubmit = async () => {
    setLogoutErrorMessage('');
    try {
      await logoutFromAllDevices().unwrap();
      handleClose();
      dispatch(authApi.util.resetApiState());
      clearToken();
      window.location.replace(logoutPageUrl);
    } catch (error: any) {
      if (error?.status === 401 || error?.status === 403) {
        handleClose();
        dispatch(authApi.util.resetApiState());
        clearToken();
        window.location.replace(logoutPageUrl);
        return;
      }

      setLogoutErrorMessage(error?.data?.message || t('somethingWrong'));
    }
  };

  return (
    <Modal
      modalKey="logoutFromDevicesModal"
      title={t('logout')}
      onClose={handleClose}
      Footer={
        <div className="flex w-full gap-1.5x">
          <Button
            variant="primary"
            size="medium"
            className="flex-1"
            isLoading={isLoading}
            disabled={isLoading}
            onClick={onSubmit}
          >
            {t('getOut')}
          </Button>
          <Button
            variant="secondary"
            size="medium"
            className="flex-1"
            onClick={handleClose}
          >
            {t('cancel')}
          </Button>
        </div>
      }
    >
      <div className="flex flex-col gap-3x">
        <p className="text-body_2 text-gray__dark_2">
          {t('logoutFromAllDevicesModalDescription')}
        </p>
      </div>
    </Modal>
  );
};

export default LogoutFromDevicesModal;
